import { useContext, useEffect, useState } from "react";

import { Container, Grid } from "@material-ui/core";
import Icon from "@material-ui/core/Icon";

import Loading from "../../../components/basics/Loading";
import Btn from "../../../components/buttons/Btn";
import HeaderModule from "../../../components/header/HeaderModule";
import SearchSelect from "../../../components/inputs/SearchSelect";

import SearchDialog from "../../../patterns/modals/SearchDialog";

import { QueryParamsContext } from "../../../context/QueryParamsContext";

import { PrescricaoContext } from "./contexts/PrescricaoContext";
import usePrescricaoController from "./controllers/PrescricaoController";
import { PainelContainer } from "./styles/Prescricao";
import AccordionPrescricaoHistorico from "./children/AccordionPrescricaoHistorico";
import AccordionPrescricaoDependentes from "./children/AccordionPrescricaoDependentes";
import ModalPrescricaoCadastro from "./children/ModalPrescricaoCadastro";

// falta criar a lógica de criação, edição de prescrição
// para cliente principal e dependentes

const PrescricaoListagem = () => {
  const { queryParams } = useContext(QueryParamsContext);
  const { handleSelectClient, handleSelectClientModal, clientGetOptionLabel } =
    usePrescricaoController();
  const { mainClient, loading, modalPrescriptionOpen } =
    useContext(PrescricaoContext);

  const [modalClientOpen, setModalClientOpen] = useState(false);

  useEffect(() => {
    console.log("mainClient:", mainClient);
  }, [mainClient, queryParams]);

  const columnsClienteSearch = [
    { label: "CÓD.", id: "id" },
    { label: "Nome", id: "razao", align: "center" },
    {
      label: "Apelido",
      id: "apelido",
      align: "center",
    },
    {
      label: "CNPJ/CPF",
      id: "cpfcnpj",
      align: "center",
    },
  ];

  return (
    <>
      <Loading open={loading.screen} />
      <HeaderModule title="PRESCRIÇÃO ÓTICA" />

      {modalClientOpen && (
        <SearchDialog
          open={modalClientOpen}
          setOpen={setModalClientOpen}
          columns={columnsClienteSearch}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectClientModal}
          route="prouser/clientes/v1"
          fields={{ "prouser.clientes": "id,razao,apelido,cpfcnpj" }}
          title="CLIENTES"
        />
      )}

      {modalPrescriptionOpen && <ModalPrescricaoCadastro />}

      <PainelContainer />

      <Container maxWidth="xl">
        <Grid container spacing={2}>
          <Grid item sm={10}>
            <SearchSelect
              descriptionField="razao"
              variant="filled"
              value={mainClient}
              setValue={handleSelectClient}
              label="Cliente"
              getOptionLabel={clientGetOptionLabel}
              route="prouser/clientes/v1"
              filter="id,razao,apelido,cpfcnpj"
              fields={{ "prouser.clientes": "id,razao,apelido,cpfcnpj" }}
            />
          </Grid>
          <Grid item sm={2}>
            <Btn
              label={<Icon> search</Icon>}
              full="true"
              onClick={() => setModalClientOpen(true)}
            />
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <AccordionPrescricaoHistorico />

          {queryParams.colaborador === "S" && (
            <AccordionPrescricaoDependentes />
          )}
        </Grid>
      </Container>
    </>
  );
};

export default PrescricaoListagem;
